"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PSCName$ = exports.PSCName$outboundSchema = exports.PSCName$inboundSchema = void 0;
exports.pscNameToJSON = pscNameToJSON;
exports.pscNameFromJSON = pscNameFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.PSCName$inboundSchema = z.object({
    forename: z.nullable(z.string()),
    middle_name: z.nullable(z.string()),
    surname: z.nullable(z.string()),
    title: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "middle_name": "middleName",
    });
});
/** @internal */
exports.PSCName$outboundSchema = z.object({
    forename: z.nullable(z.string()),
    middleName: z.nullable(z.string()),
    surname: z.nullable(z.string()),
    title: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        middleName: "middle_name",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PSCName$;
(function (PSCName$) {
    /** @deprecated use `PSCName$inboundSchema` instead. */
    PSCName$.inboundSchema = exports.PSCName$inboundSchema;
    /** @deprecated use `PSCName$outboundSchema` instead. */
    PSCName$.outboundSchema = exports.PSCName$outboundSchema;
})(PSCName$ || (exports.PSCName$ = PSCName$ = {}));
function pscNameToJSON(pscName) {
    return JSON.stringify(exports.PSCName$outboundSchema.parse(pscName));
}
function pscNameFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PSCName$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PSCName' from JSON`);
}
//# sourceMappingURL=pscname.js.map